import React from 'react'
import styled, { keyframes } from 'styled-components'

// Create the keyframes
const skBounce = keyframes`
  0%, 100% {
    transform: scale(0.0);
  } 50% {
      transform: scale(1.0);
    }
`

const skRotate = keyframes`
 100% {
 transform: rotate(360deg)
 }
`

// -CONTAINER
const SpinnerContainer = styled.div<{
  inline: boolean
  containerMargin: string
}>`
  width: 40px;
  height: 40px;
  position: relative;
  text-align: center;
  animation: ${skRotate} 2s infinite linear;
  ${({ inline }) =>
    inline &&
    `
    width: 1em;
    height: 1em;
    margin: 0;
    display: inline-block;
  `}
  margin: ${props => props.containerMargin || '100px auto'};
`

// -CONTAINER DOT
const Dot = styled.div<{ bgColor: string }>`
  width: 60%;
  height: 60%;
  display: inline-block;
  position: absolute;
  top: 0;
  background-color: ${props => (props.bgColor ? props.bgColor : '#333')};
  border-radius: 100%;
  animation: ${skBounce} 2s infinite ease-in-out;
`
const Dot2 = styled(Dot)`
  top: auto;
  bottom: 0;
  animation-delay: -1s;
`

type Props = {
  isInline?: boolean
  color?: string
  containerMargin?: string
}

export const Spinner: React.FunctionComponent<Props> = ({
  isInline,
  color,
  containerMargin,
}) => {
  return (
    <SpinnerContainer containerMargin={containerMargin} inline={isInline}>
      <Dot bgColor={color} />
      <Dot2 bgColor={color} />
    </SpinnerContainer>
  )
}
